import { Component, Input } from '@angular/core'
@Component({
    selector: 'app-timeline-step',
    templateUrl: './timeline-step.component.html',
    styleUrls: ['./timeline-step.component.scss'],
})
export class TimelineStepComponent {
    @Input() status: any
    getStepClass() {
        if (this.status.current) {
            return this.status.id === 4 ? 'past' : this.status.id < 5 ? 'current' : 'reject'
        }
        return this.status.future ? 'future' : 'past'
    }
}
